import '../partials/bootstrap'
import '../controllers/email_input_controller'
import '../vendor/cookies';
import '../controllers/view_tour_controller'
import '../controllers/attendance_picker_controller'
import '../controllers/date_range_picker_controller'
import '../controllers/search_with_suggestions_date_controller'
import '../controllers/add_place_suggested_places_controller';
import './components/scrollable_container_controller'
